//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "../../layouts/Header.vue";
import FeaturedArchitecture from "../../components/FeaturedArchitecture.vue";
import Footer from "../../layouts/Footer.vue";
import FeaturedBlocks from '../../components/FeaturedBlocks.vue'
import CtaBanner from '../../components/CtaBanner.vue'

export default {
  name: "technical-advisory",
  components: {
    Header,
    FeaturedArchitecture,
    FeaturedBlocks,
    Footer,
    CtaBanner
    
  },
  head: {
    title: "Technical Advisory | Mazecare",
    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "Mazecare provides technical advisory services to help healthcare leaders make informed decisions",
      },
    ],
  },
};
